import React from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { Flex, GradientButton, Text } from '../../../components';
import { useHistory } from 'react-router-dom';

import Trickle from '../../../assets/Trickle.svg';

const LogoText = styled.img`
  width: 65%;
  max-width: 300px;
`;



const Header = () => {
  const history = useHistory();

  const publicJoinWaitlist = () => {
    axios
      .put('/api/release/join-waitlist')
      .then(async (res) => {
        alert('Joined Waitlist, Monitor your discord\'s account associated email');
      })
      .catch(err => {
        if (err.response.status == 401) {
          history.push('/dashboard');
        }
      });
  }

  return (
    <Flex id="home" dir="column" w="100%" align="center">
      <LogoText src={Trickle} alt="trickle" />
      <Flex h="64px" />
      <Flex dir="column" w="80%" align="center">
        <Text.Body size="21" center>
          A Steady Drip of Success.
        </Text.Body>
        <Flex h="48px" />
        <GradientButton w="180px" text="Join Waitlist" onClick={() => publicJoinWaitlist()} />
        <Flex h="24px" />
        <Text.Body color="#7178B2" size="12" center>
          $499 for the first month, then $50 per month
        </Text.Body>
      </Flex>
    </Flex>
  )
};

export default Header;
